var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLowRisk(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1246_34597)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.9999 12.856C19.9999 8.43774 16.4182 4.85602 11.9999 4.85602C7.58166 4.85602 3.99994 8.43774 3.99994 12.856",
    stroke: "#1A1B1D",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.8085 18.357C19.1668 16.9232 19.9999 14.9869 19.9999 12.856C19.9999 8.43774 16.4182 4.85602 11.9999 4.85602C7.58166 4.85602 3.99994 8.43774 3.99994 12.856C3.99994 14.9869 4.83307 16.9232 6.19136 18.357",
    stroke: "#1A1B1D",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.1487 12.6443L10.3854 13.9543L7.89021 11.623L11.1487 12.6443Z",
    fill: "#1A1B1D",
    stroke: "#1A1B1D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 9.9152,
    y: 14.8106,
    width: 3.5,
    height: 3.5,
    rx: 1.75,
    transform: "rotate(-59.7708 9.9152 14.8106)",
    stroke: "#1A1B1D",
    strokeWidth: 1.5
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1246_34597"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLowRisk);
export default __webpack_public_path__ + "static/media/low-risk.c712760cd63d4bf5c54a25812e85b312.svg";
export { ForwardRef as ReactComponent };